import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_ClinicalSupervision = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='BFCS_ClinicalSupervision' className='file-pdf-document'>

            <div className='file-template'>

                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Staff Name and credentials:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Clinical Supervisor and credentials:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtStaffName' name='txtStaffName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClinicalSupervisor' name='txtClinicalSupervisor' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Session Start Time:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Session End Time:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Type:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='time' id='txtSessionStartTime' name='txtSessionStartTime' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtSessionEndTime' name='txtSessionEndTime' className='add-only' /> </td>
                        <td className='w-250'>

                            <input type='radio' id='rbType_Individual' name='rbType' className='add-only' value='Individual' /> Individual &nbsp;
                            <input type='radio' id='rbType_Group' name='rbType' className='add-only' value='Group' /> Group
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Focus of Session:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbFocusSession_CaseReview' name='rbFocusSession' className='add-only' value='CaseReview' /> Case Review</td>
                        <td className='w-200'> <input type='radio' id='rbFocusSession_PSRSkillsTraining' name='rbFocusSession' className='add-only' value='PSRSkillsTraining' /> PSR Skills Training</td>
                        <td className='w-200'> <input type='radio' id='rbFocusSession_CPSTInterventions' name='rbFocusSession' className='add-only' value='CPSTInterventions' /> CPST Interventions</td>
                        <td className='w-200'> <input type='radio' id='rbFocusSession_CrisisInterventionReview' name='rbFocusSession' className='add-only' value='CrisisInterventionReview' /> Crisis Intervention Review</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFocusSession_Training' name='rbFocusSession' className='add-only' value='Training' /> Training:
                            &nbsp;
                            <input type='text' id='txtInformationFocusSession_Training' name='txtInformationFocusSession_Training' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center>
                        <b>Review of Cases</b>
                        <span className='small'>Service and date range of at least 3 cases</span>
                    </center>
                </p>

                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-500'> <span className='eleHeader'>Concerns and/or behaviors addressed.:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtConcernsBehaviors_1' name='txtConcernsBehaviors_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_2' name='txtClientName_2' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtConcernsBehaviors_2' name='txtConcernsBehaviors_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_3' name='txtClientName_3' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtConcernsBehaviors_3' name='txtConcernsBehaviors_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>LMHP subsequent recommendations for supervisee to take:</span>
                    <textarea id='txtLmhpSubsequent' name='txtLmhpSubsequent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LMHP Recommendations for training:</span>
                    List all recommendation for on-going training (documentation, PSR Skills, Engagement Training, Crisis planning, HIPPA, Booster training, etc.)
                    <textarea id='txtLmhpRecommendations' name='txtLmhpRecommendations' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LMHPs Recommendations/Feedback from Progress note review.:</span>
                    <span className='small'>(review at least 3 progress notes)</span>
                </p>
                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Client:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of service:</span> </td>
                        <td className='w-350'> <span className='eleHeader'>Notes (Feedback):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClient_1' name='txtClient_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateService_1' name='txtDateService_1' className='add-only' /> </td>
                        <td className='w-350'>
                            <input type='radio' id='rbNotes1_Sufficient' name='rbNotes1' className='add-only' value='Sufficient' /> Progress note is sufficient
                            <br />
                            <input type='radio' id='rbNotes1_Insufficient' name='rbNotes1' className='add-only' value='Insufficient' /> Progress note is insufficient and more training is needed

                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClient_2' name='txtClient_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateService_2' name='txtDateService_2' className='add-only' /> </td>
                        <td className='w-350'>
                            <input type='radio' id='rbNotes2_Sufficient' name='rbNotes2' className='add-only' value='Sufficient' /> Progress note is sufficient
                            <br />
                            <input type='radio' id='rbNotes2_Insufficient' name='rbNotes2' className='add-only' value='Insufficient' /> Progress note is insufficient and more training is needed

                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClient_3' name='txtClient_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateService_3' name='txtDateService_3' className='add-only' /> </td>
                        <td className='w-350'>
                            <input type='radio' id='rbNotes3_Sufficient' name='rbNotes3' className='add-only' value='Sufficient' /> Progress note is sufficient
                            <br />
                            <input type='radio' id='rbNotes3_Insufficient' name='rbNotes3' className='add-only' value='Insufficient' /> Progress note is insufficient and more training is needed

                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>List any new clients:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>List non-compliant clients:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNewClients_1' name='txtNewClients_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtListClient_1' name='txtListClient_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNewClients_2' name='txtNewClients_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtListClient_2' name='txtListClient_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNewClients_3' name='txtNewClients_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtListClient_3' name='txtListClient_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNewClients_4' name='txtNewClients_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtListClient_4' name='txtListClient_4' className='add-only' /> </td>
                    </tr>
                </table> 


            </div>
        </form>

    )
} 